import React from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import { Textarea } from '@components/basics/forms/inputs/Textarea';
import { COMMENT_MAX_CHARS } from '@utils/constants';

export function CommentTextArea({
  commentText,
  setCommentText,
  hasError,
  isLoading,
}: {
  commentText: string;
  setCommentText: (text: string) => void;
  isLoading: boolean;
  hasError: boolean;
}) {
  const [charCount, setCharCount] = React.useState(commentText.length);

  return (
    <div className="grid w-full">
      <Textarea
        hasError={hasError}
        placeholder={isLoading ? '...' : 'What would you like to comment...'}
        className="h-28"
        onChange={e => {
          setCommentText(e.target.value);
          setCharCount(e.target.value.length);
        }}
        onFocus={e => {
          setCharCount(e.target.value.length);
        }}
        value={commentText}
      />
      <div className="mt-1 flex w-full flex-row-reverse items-start justify-between">
        <div className="flex items-center gap-x-1">
          <p className="font-base text-base-s font-medium text-base400">
            {charCount}/{COMMENT_MAX_CHARS}
          </p>
          <div className="block h-4 w-4">
            <CircularProgressbar
              value={charCount}
              maxValue={COMMENT_MAX_CHARS}
              strokeWidth={15}
              styles={buildStyles({
                pathColor: hasError ? '#EF4444' : '#1F1F1F',
                trailColor: '#F5F5F5',
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
